import React from "react";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { TextInput } from "../../../components/textInput/TextInput";
import { DateInput } from "../../../components/dateInput/DateInput";
import { CustomButton } from "../../../components/customButton/CustomButton";
import toast from "react-hot-toast";
import moment from "moment";

export const SugerenciasMonitoreoFilters = ({
    delegaciones,
    estadosSugerencias = [],
    handleTextClean,
    handleTextFilter,
    handleSearch,
    handleChange,
    handleChangeDate,
    filters
}) => {

    const onClickSearch = () => {

        if (!filters?.fechaDesde) {
            return toast.error("La fecha desde es requerida");
        };
        if (!filters?.fechaHasta) {
            return toast.error("La fecha hasta es requerida");
        };

        if (moment(filters?.fechaDesde).isAfter(moment(filters?.fechaHasta))) {
            return toast.error("La fecha desde no puede ser posterior a la fecha hasta");
        };
        
        if (!filters?.idEstado) {
            return toast.error("El estado es requerido");
        };

        handleSearch();
    }

    return (
        <Grid container spacing={2} size="grow">
            <Grid size={{ xs: 12, sm: 6, md: 4, xl: 2.5 }}>
                <TextInput
                    searchIcon
                    label="Buscar"
                    name="txtFiltro"
                    onClearButtonClick={handleTextClean}
                    value={filters?.txtFiltro}
                    onChange={handleChange}
                    onKeyUp={handleTextFilter}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, xl: 2.5 }}>
                <FormControl sx={{ backgroundColor: 'white', width: '100%' }} size='small'>
                    <InputLabel id='select-delegacion'>Delegación Resp. Monitoreo</InputLabel>
                    <Select
                        labelId='select-delegacion'
                        options={delegaciones}
                        label='Delegación Resp. Monitoreo'
                        onChange={handleChange}
                        value={filters?.idDelegacion || undefined}
                        name='idDelegacion'
                    >
                        {delegaciones && delegaciones.map((delegacion) => {
                            return <MenuItem key={delegacion.id} value={delegacion.id}> {delegacion.displayName} </MenuItem>
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, xl: 2 }}>
                <FormControl sx={{ bgcolor: "white", width: "100%" }} size="small">
                    <InputLabel id="select-area-estado">
                        Estado
                    </InputLabel>
                    <Select
                        labelId="select-area-estado"
                        options={estadosSugerencias}
                        label="Estado"
                        onChange={handleChange}
                        value={filters?.idEstado || ""}
                        name="idEstado"
                    >
                        {estadosSugerencias.map((tipo) => {
                            return (
                                <MenuItem key={tipo.id} value={tipo.id}>
                                    {" "}
                                    {tipo.displayName}{" "}
                                </MenuItem>
                            );
                        })}
                    </Select>
                </FormControl>
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, xl: 2 }}>
                <DateInput
                    label="Fecha desde"
                    value={filters?.fechaDesde}
                    onChange={(value) => handleChangeDate("fechaDesde", value)}
                />
            </Grid>
            <Grid size={{ xs: 12, sm: 6, md: 4, xl: 2 }}>
                <DateInput
                    label="Fecha hasta"
                    value={filters?.fechaHasta}
                    onChange={(value) => handleChangeDate("fechaHasta", value)}
                />
            </Grid>
            <Grid sx={{ textAlign: 'right' }} size={{ xs: 12, sm: 6, md: 4, xl: 1 }}>
                <CustomButton size="small" onClick={onClickSearch}>
                    Buscar
                </CustomButton>
            </Grid>
        </Grid>
    )
}